module.exports = __webpack_public_path__ + "img/insig-line.d262a737.svg";